import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type Phone } from 'entities/Phone/model/Phone'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class RowNumber extends RowBase<Phone> {
  constructor(origin: Phone, private _entities: IEntitiesStore) {
    super(origin)

    makeObservableRowBase(this, {
      disabled: computed,
    })
  }

  get disabled() {
    if (this._entities.subscriptionStore.isPAYGPlan && this.isDisabled) return true

    return this.isDisabled
  }
}
